import { HotelServiceProviderType } from "@/types/hotelService";

export const REQUEST_SERVICE_PROVIDER_TYPES: HotelServiceProviderType[] = [
  HotelServiceProviderType.GUEST_SERVICE,
  HotelServiceProviderType.EXTERNAL_SERVICE,
];
